document.addEventListener("DOMContentLoaded", () => {
    const sendBtn = document.getElementById("chat-send-i");
    const input   = document.getElementById("chat-input-i");
    const box     = document.getElementById("chat-messages-i");

    if (!sendBtn) return;

    function appendMessage(who, text) {
        const wrapper = document.createElement("div");
        wrapper.className = who === "user" ? "d-flex justify-content-end mb-10" : "d-flex justify-content-start mb-10";

        if (who === "user") {
            wrapper.className = "d-flex justify-content-end mb-10";
            wrapper.innerHTML = `
              <div class="d-flex flex-column align-items-start">
                <div class="d-flex align-items-center mb-2">
                  <div class="ms-3">
                    <a href="#" class="fs-5 fw-bold text-gray-900 text-hover-primary me-1">Tú</a>
                  </div>
                </div>

                <div class="p-5 rounded bg-light-info text-gray-900 fw-semibold mw-lg-400px text-start" data-kt-element="message-text">
                  ${text}
                </div>
              </div>
            `;
        } else {
            texto = text.replace(/\n/g, "<br><br>");
            texto = texto.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

            wrapper.className = "d-flex justify-content-start mb-10";
            wrapper.innerHTML = `
              <div class="d-flex flex-column align-items-end">
                <div class="d-flex align-items-center mb-2">
                  <div class="me-3">
                    <a href="#" class="fs-5 fw-bold text-gray-900 text-hover-primary ms-1">Asistente</a>
                  </div>  
                </div>
                <div class="p-5 rounded bg-light-primary text-gray-900 fw-semibold mw-lg-400px text-end" data-kt-element="message-text">
                  ${texto}
                </div>
              </div>
            `;
        }

        box.append(wrapper);
        box.scrollTop = box.scrollHeight;
    }

    async function sendMessage() {
        const text = input.value.trim();
        if (!text) return;
        appendMessage("user", text);
        input.value = "";
        // Aviso de “pensando…”
        appendMessage("bot", "<em>Pensando…</em>");

        try {
            const res = await fetch("/ai_chat_imported", {
                method: "POST",
                headers: { "Content-Type": "application/json", "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content },
                body: JSON.stringify({ message: text })
            });
            const json = await res.json();
            // Eliminar “Pensando…”
            box.lastChild.remove();
            box.scrollTop = box.scrollHeight;
            console.log("√√jsonjsonjsonjson")
            console.log(json)

            if (json.error) {
                appendMessage("bot", `<span class="text-danger">Error: ${json.error}</span>`);
            } else {
                appendMessage("bot", json.reply);
                if (json.reply.chart_data) {
                    const chartId = "chartdiv-" + Date.now(); // id único
                    const chartContainer = document.getElementById("charts-container");
                    chartContainer.innerHTML += `<div id="${chartId}" style="width:100%; height:400px; margin-top:20px;"></div>`;

                    // Dibujar gráfico
                    drawChart(chartId, json.reply.chart_data);
                }
            }
        } catch (e) {
            appendMessage("bot", `<span class="text-danger">Error al conectar con el servidor.</span>`);
        }
    }

    sendBtn.addEventListener("click", sendMessage);
    input.addEventListener("keypress", (e) => {
        if (e.key === "Enter") sendMessage();
    });

    var initDaterangepicker = () => {
        // var start = moment().subtract(29, "days");
        // var end = moment();
        var start = moment().startOf("month");
        var end = moment().endOf("month");
        var input = $("#daterangepicker-home");

        function cb(start, end) {
            // input.html(start.format("MMMM D, YYYY") + " - " + end.format("MMMM D, YYYY"));
            $("#daterangepicker-home .text-gray-600").text(
                start.format("MMMM D, YYYY") + " - " + end.format("MMMM D, YYYY")
            );
        }

        input.daterangepicker({
            startDate: start,
            endDate: end,
            opens: 'left',
            ranges: {
                "Hoy": [moment(), moment()],
                "Ayer": [moment().subtract(1, "days"), moment().subtract(1, "days")],
                "Últimos 7 días": [moment().subtract(6, "days"), moment()],
                "Últimos 30 días": [moment().subtract(29, "days"), moment()],
                "Mes Actual": [moment().startOf("month"), moment().endOf("month")],
                "Mes Pasado": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")]
            },
            "locale": {
                "format": "DD/MM/YYYY",
                "separator": " - ",
                "applyLabel": "Aplicar",
                "cancelLabel": "Cancelar",
                "fromLabel": "De",
                "toLabel": "A",
                "customRangeLabel": "Personalizado",
                "weekLabel": "S",
                "daysOfWeek": [
                    "Do",
                    "Lu",
                    "Ma",
                    "Mi",
                    "Ju",
                    "Vi",
                    "Sa"
                ],
                "monthNames": [
                    "Enero",
                    "Febrero",
                    "Marzo",
                    "Abril",
                    "Mayo",
                    "Junio",
                    "Julio",
                    "Agosto",
                    "Septiembre",
                    "Octubre",
                    "Noviembre",
                    "Deciembre"
                ],
                "firstDay": 1
            },
        }, cb);

        cb(start, end);
    }

    // Evento cuando el usuario aplica un nuevo rango
    $('#daterangepicker-home').on('apply.daterangepicker', function(ev, picker) {
        let start = picker.startDate.format('YYYY-MM-DD');
        let end   = picker.endDate.format('YYYY-MM-DD');

        console.log("Fecha inicial:", start);
        console.log("Fecha final:", end);

        // Aquí haces tu petición AJAX o actualización de gráfico/tabla:
        // loadData(start, end);
        $.ajax({
            url: "/dashboard/update_slider",
            method: "GET",
            dataType: "html",
            data: {
                start_date: start,
                end_date: end
            },
            success: function(response) {
                $("#cards-slider").html(response); // Actualiza tarjetas

                document.querySelectorAll('[data-tns="true"]').forEach(el => {
                    tns({
                        container: el,
                        items: 1,
                        nav: true,
                        controls: false,
                        center: true,
                        mouseDrag: true,
                        autoplay: false,
                        swipeAngle: true,
                        speed: 400,
                    });
                });

                document.querySelectorAll(".chartdiv").forEach((el) => {
                    // ⚠️ Tiny Slider clona slides. Evitamos inicializar gráficos en los clones.
                    if (el.closest(".tns-slide-cloned")) return;

                    // Asegurarse que es un elemento válido
                    if (!(el instanceof HTMLElement)) return;

                    // Eliminar root anterior si existe
                    if (el.am5Root) {
                        el.am5Root.dispose();
                        el.am5Root = null;
                    }

                    let sucursales;
                    try {
                        sucursales = JSON.parse(el.dataset.sucursales || "[]");
                    } catch (e) {
                        console.error("JSON inválido en", el.id, e);
                        return;
                    }
                    var isMobile = window.innerWidth < 600;

                    // No inicializar si no hay datos
                    if (!Array.isArray(sucursales) || sucursales.length === 0) return;

                    // Crear nuevo Root
                    const root = am5.Root.new(el);
                    el.am5Root = root;

                    root.setThemes([am5themes_Animated.new(root)]);

                    // Crear chart
                    const chart = root.container.children.push(
                        am5xy.XYChart.new(root, {
                            panX: true,
                            panY: true,
                            wheelX: "panX",
                            wheelY: "zoomX",
                            layout: root.verticalLayout
                        })
                    );

                    // Eje X
                    const xAxis = chart.xAxes.push(
                        am5xy.CategoryAxis.new(root, {
                            categoryField: "sucursal",
                            renderer: am5xy.AxisRendererX.new(root, { minGridDistance: 30 })
                        })
                    );
                    xAxis.get("renderer").labels.template.setAll({
                        rotation: -90,
                        maxWidth: isMobile ? 70 : 120,
                        centerY: am5.p50,
                        centerX: am5.p100,
                        textAlign: "right",
                    });
                    xAxis.data.setAll(sucursales);

                    // Eje Y
                    const yAxis = chart.yAxes.push(
                        am5xy.ValueAxis.new(root, {
                            renderer: am5xy.AxisRendererY.new(root, {})
                        })
                    );

                    // Serie Presupuesto (Column)
                    const seriesPresupuesto = chart.series.push(
                        am5xy.ColumnSeries.new(root, {
                            name: "Ingreso",
                            xAxis: xAxis,
                            yAxis: yAxis,
                            valueYField: "ingreso_sin_iva",
                            categoryXField: "sucursal",
                            tooltip: am5.Tooltip.new(root, {
                                labelText: "{name}: {valueY}"
                            })
                        })
                    );
                    seriesPresupuesto.data.setAll(sucursales);

                    // Serie Ejercido (Line)
                    const seriesEjercido = chart.series.push(
                        am5xy.LineSeries.new(root, {
                            name: "Egreso",
                            xAxis: xAxis,
                            yAxis: yAxis,
                            valueYField: "egreso_con_iva",
                            categoryXField: "sucursal",
                            stroke: am5.color(0xff0000),
                            tooltip: am5.Tooltip.new(root, {
                                labelText: "{name}: {valueY}"
                            })
                        })
                    );
                    seriesEjercido.strokes.template.setAll({ strokeWidth: 2 });
                    seriesEjercido.bullets.push(() => {
                        return am5.Bullet.new(root, {
                            sprite: am5.Circle.new(root, {
                                radius: 5,
                                fill: seriesEjercido.get("stroke")
                            })
                        });
                    });
                    seriesEjercido.data.setAll(sucursales);

                    // Cursor y leyenda
                    chart.set(
                        "cursor",
                        am5xy.XYCursor.new(root, {
                            behavior: "none",
                            xAxis: xAxis
                        })
                    );

                    chart.children.push(
                        am5.Legend.new(root, {
                            centerX: am5.p50,
                            x: am5.p50
                        })
                    ).data.setAll([seriesPresupuesto, seriesEjercido]);
                });
            },
            error: function() {
                console.error("Error al actualizar tarjetas.");
            }
        });
    });

    function drawBalanceChart() {
        if (typeof am5 === "undefined") return;

        var element = document.getElementById("grafica");
        if (!element) return;

        var root;

        var init = function () {
            root = am5.Root.new(element);
            root.setThemes([am5themes_Animated.new(root)]);

            var isMobile = window.innerWidth < 600;

            var chart = root.container.children.push(
                am5xy.XYChart.new(root, {
                    panX: false,
                    panY: false,
                    layout: root.verticalLayout,
                })
            );

            // -------------------------------
            // 🔥 Adaptamos tu data a amCharts
            // -------------------------------
            info = JSON.parse(element.dataset.unidades)
            var data = info.map(item => ({
                category: item.FAMILIA,   // Etiqueta del eje X
                income: item.PRESUPUESTO,
                expenses: item.EJERCIDO,
                columnSettings: {
                    fill: am5.color(KTUtil.getCssVariableValue("--bs-secorp")),
                },
                strokeSettings: {
                    strokeWidth: 2,
                    strokeDasharray: [4, 4],
                }
            }));

            // -------------------------------
            // 📌 EJE X
            // -------------------------------
            var xAxis = chart.xAxes.push(
                am5xy.CategoryAxis.new(root, {
                    categoryField: "category",
                    renderer: am5xy.AxisRendererX.new(root, {}),
                })
            );

            xAxis.data.setAll(data);

            xAxis.get("renderer").labels.template.setAll({
                oversizedBehavior: "wrap",
                maxWidth: isMobile ? 70 : 120,
                rotation: isMobile ? -75 : -35,
                fontSize: isMobile ? 9 : 12,
                centerY: am5.p50,
                centerX: isMobile ? am5.p100 : am5.p50,
                textAlign: "right",
                fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-500")),
            });

            xAxis.get("renderer").grid.template.setAll({
                disabled: true,
            });

            // -------------------------------
            // 📌 EJE Y
            // -------------------------------
            var yAxis = chart.yAxes.push(
                am5xy.ValueAxis.new(root, {
                    min: 0,
                    calculateTotals: false,
                    renderer: am5xy.AxisRendererY.new(root, {}),
                })
            );

            yAxis.get("renderer").labels.template.setAll({
                paddingTop: 0,
                fontWeight: "400",
                fontSize: 11,
                fill: am5.color(KTUtil.getCssVariableValue("--bs-gray-500")),
            });

            yAxis.get("renderer").grid.template.setAll({
                stroke: am5.color(KTUtil.getCssVariableValue("--bs-gray-300")),
                strokeWidth: 1,
                strokeDasharray: [3],
            });

            // -------------------------------
            // 📊 Series 1: PRESUPUESTO
            // -------------------------------
            var series1 = chart.series.push(
                am5xy.ColumnSeries.new(root, {
                    name: "Ingreso",
                    xAxis: xAxis,
                    yAxis: yAxis,
                    valueYField: "income",
                    categoryXField: "category",
                    tooltip: am5.Tooltip.new(root, {
                        labelText: "{name} en {categoryX}: {valueY}",
                    }),
                })
            );

            series1.columns.template.setAll({
                tooltipY: am5.percent(10),
                templateField: "columnSettings",
                strokeOpacity: 0,
                cornerRadiusTR: 6,
                cornerRadiusTL: 6,
            });

            series1.data.setAll(data);

            // -------------------------------
            // 📈 Series 2: EJERCIDO
            // -------------------------------
            var series2 = chart.series.push(
                am5xy.LineSeries.new(root, {
                    name: "Egreso",
                    xAxis: xAxis,
                    yAxis: yAxis,
                    valueYField: "expenses",
                    categoryXField: "category",
                    stroke: am5.color(KTUtil.getCssVariableValue("--bs-danger")),
                    fill: am5.color(KTUtil.getCssVariableValue("--bs-danger")),
                    tooltip: am5.Tooltip.new(root, {
                        labelText: "{name} en {categoryX}: {valueY}",
                    }),
                })
            );

            series2.strokes.template.setAll({
                strokeWidth: 3,
                templateField: "strokeSettings",
            });

            series2.data.setAll(data);

            series2.bullets.push(function () {
                return am5.Bullet.new(root, {
                    sprite: am5.Circle.new(root, {
                        radius: 5,
                        strokeWidth: 3,
                        stroke: am5.color(KTUtil.getCssVariableValue("--bs-danger")),
                    }),
                });
            });

            chart.set("cursor", am5xy.XYCursor.new(root, {}));
            chart.get("cursor").lineX.set("visible", false);
            chart.get("cursor").lineY.set("visible", false);

            // -------------------------------
            // 🏷️ Leyenda
            // -------------------------------
            var legend = chart.children.push(
                am5.Legend.new(root, {
                    centerX: am5.p50,
                    x: am5.p50,
                })
            );

            legend.data.setAll(chart.series.values);

            // chart.set("scrollbarX", am5.Scrollbar.new(root, {
            //     orientation: "horizontal"
            // }));

            chart.appear(1000, 100);
            series1.appear();
        };

        console.log(am5)

        am5.ready(init);
    }

    function drawChart(chartId, chartData) {
        const chartsContainer = document.getElementById("charts-container");

        // 🔥 Eliminar cualquier gráfico previo (roots y divs)
        am5.registry.rootElements.forEach(root => root.dispose());
        chartsContainer.innerHTML = "";

        // Crear un nuevo div dentro del contenedor
        const newDiv = document.createElement("div");
        newDiv.id = chartId;
        newDiv.style.width = "100%";
        newDiv.style.height = "400px";
        newDiv.style.marginTop = "20px";
        chartsContainer.appendChild(newDiv);

        let root = am5.Root.new(chartId);
        root.setThemes([am5themes_Animated.new(root)]);

        let chart;

        if (chartData.type === "bar") {
            chart = root.container.children.push(
                am5xy.XYChart.new(root, { panX: true, panY: true, wheelX: "panX", wheelY: "zoomX" })
            );

            let xAxis = chart.xAxes.push(
                am5xy.CategoryAxis.new(root, {
                    categoryField: "label",
                    renderer: am5xy.AxisRendererX.new(root, { minGridDistance: 30 })
                })
            );

            let yAxis = chart.yAxes.push(
                am5xy.ValueAxis.new(root, { renderer: am5xy.AxisRendererY.new(root, {}) })
            );

            let series = chart.series.push(
                am5xy.ColumnSeries.new(root, {
                    name: "Series 1",
                    xAxis,
                    yAxis,
                    valueYField: "value",
                    categoryXField: "label"
                })
            );

            let data = chartData.labels.map((label, i) => ({
                label,
                value: chartData.values[i]
            }));

            xAxis.data.setAll(data);
            series.data.setAll(data);

        } else if (chartData.type === "line") {
            chart = root.container.children.push(am5xy.XYChart.new(root, {}));

            let xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, { categoryField: "label" }));
            let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {}));

            let series = chart.series.push(
                am5xy.LineSeries.new(root, {
                    xAxis,
                    yAxis,
                    valueYField: "value",
                    categoryXField: "label"
                })
            );

            let data = chartData.labels.map((label, i) => ({
                label,
                value: chartData.values[i]
            }));

            xAxis.data.setAll(data);
            series.data.setAll(data);

        } else if (chartData.type === "pie") {
            chart = root.container.children.push(am5percent.PieChart.new(root, {}));

            let series = chart.series.push(am5percent.PieSeries.new(root, {
                valueField: "value",
                categoryField: "label"
            }));

            let data = chartData.labels.map((label, i) => ({
                label,
                value: chartData.values[i]
            }));

            series.data.setAll(data);
        }
    }

    document.querySelectorAll(".chartdiv").forEach((el) => {
        // ⚠️ Tiny Slider clona slides. Evitamos inicializar gráficos en los clones.
        if (el.closest(".tns-slide-cloned")) return;

        // Asegurarse que es un elemento válido
        if (!(el instanceof HTMLElement)) return;

        // Eliminar root anterior si existe
        if (el.am5Root) {
            el.am5Root.dispose();
            el.am5Root = null;
        }

        let sucursales;
        try {
            sucursales = JSON.parse(el.dataset.sucursales || "[]");
        } catch (e) {
            console.error("JSON inválido en", el.id, e);
            return;
        }
        var isMobile = window.innerWidth < 600;

        // No inicializar si no hay datos
        if (!Array.isArray(sucursales) || sucursales.length === 0) return;

        // Crear nuevo Root
        const root = am5.Root.new(el);
        el.am5Root = root;

        root.setThemes([am5themes_Animated.new(root)]);

        // Crear chart
        const chart = root.container.children.push(
            am5xy.XYChart.new(root, {
                panX: true,
                panY: true,
                wheelX: "panX",
                wheelY: "zoomX",
                layout: root.verticalLayout
            })
        );

        // Eje X
        const xAxis = chart.xAxes.push(
            am5xy.CategoryAxis.new(root, {
                categoryField: "sucursal",
                renderer: am5xy.AxisRendererX.new(root, { minGridDistance: 30 })
            })
        );
        xAxis.get("renderer").labels.template.setAll({
            rotation: -90,
            maxWidth: isMobile ? 70 : 120,
            centerY: am5.p50,
            centerX: am5.p100,
            textAlign: "right",
        });
        xAxis.data.setAll(sucursales);

        // Eje Y
        const yAxis = chart.yAxes.push(
            am5xy.ValueAxis.new(root, {
                renderer: am5xy.AxisRendererY.new(root, {})
            })
        );

        // Serie Presupuesto (Column)
        const seriesPresupuesto = chart.series.push(
            am5xy.ColumnSeries.new(root, {
                name: "Ingreso",
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: "ingreso_sin_iva",
                categoryXField: "sucursal",
                tooltip: am5.Tooltip.new(root, {
                    labelText: "{name}: {valueY}"
                })
            })
        );
        seriesPresupuesto.data.setAll(sucursales);

        // Serie Ejercido (Line)
        const seriesEjercido = chart.series.push(
            am5xy.LineSeries.new(root, {
                name: "Egreso",
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: "egreso_con_iva",
                categoryXField: "sucursal",
                stroke: am5.color(0xff0000),
                tooltip: am5.Tooltip.new(root, {
                    labelText: "{name}: {valueY}"
                })
            })
        );
        seriesEjercido.strokes.template.setAll({ strokeWidth: 2 });
        seriesEjercido.bullets.push(() => {
            return am5.Bullet.new(root, {
                sprite: am5.Circle.new(root, {
                    radius: 5,
                    fill: seriesEjercido.get("stroke")
                })
            });
        });
        seriesEjercido.data.setAll(sucursales);

        // Cursor y leyenda
        chart.set(
            "cursor",
            am5xy.XYCursor.new(root, {
                behavior: "none",
                xAxis: xAxis
            })
        );

        chart.children.push(
            am5.Legend.new(root, {
                centerX: am5.p50,
                x: am5.p50
            })
        ).data.setAll([seriesPresupuesto, seriesEjercido]);
    });

    initDaterangepicker();
    drawBalanceChart();
});
